module.exports = __webpack_public_path__ + "img/banner2.a6186d41.png";